import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {LoadingComponent} from "./loading/loading.component"
import { ImagePickerComponent } from './image-picker/image-picker.component';
import { LayoutComponent } from "./layout/layout.component";
import { MenuComponent } from "./menu/menu.component";
import { RouterModule } from '@angular/router';
import { RestComponent } from './_rest/rest.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { DxCheckBoxModule, DxDataGridModule, DxDateBoxModule, DxFileUploaderModule, DxFormModule, DxHtmlEditorModule, DxPopupModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule, DxTooltipModule } from 'devextreme-angular';
import { NavigationComponent } from './navigation/navigation.component';
import { DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { SuperMenuComponent } from './super-menu/super-menu.component';
import { ThemePOLOHeaderFullwidthComponent } from './_themes/POLO/header-fullwidth/header-fullwidth.component';
import { ThemePOLOCookieNotifyComponent } from './_themes/POLO/cookie-notify/cookie-notify.component';
import { ThemePOLOSearchComponent } from './_themes/POLO/search/search.component';
import { CguComponent } from './cgu/cgu.component';
import { RgpdComponent } from './rgpd/rgpd.component';
import { LayoutHeaderComponent } from './layout/layout-header/layout-header.component';
import { InstagramComponent } from './instagram/instagram.component';
import { SubMenuComponent } from './sub-menu/sub-menu.component';
import { HeaderComponent } from './header/header.component';
import { AccordionComponent } from './_themes/POLO/accordion/accordion.component';
import { LayoutFooterComponent } from './layout/layout-footer/layout-footer.component';
import { CllajinscriptionComponent } from './cllaj/cllajinscription/cllajinscription.component';
import { CllajinscriptionsalonsComponent } from './cllaj/cllajinscriptionsalons/cllajinscriptionsalons.component';
import { CllajoffresComponent } from './cllaj/cllajoffres/cllajoffres.component';
import { CllajinscriptionuserComponent } from './cllaj/cllajinscriptionuser/cllajinscriptionuser.component';
import { CllajinscriptionlieuxComponent } from './cllaj/cllajinscriptionlieux/cllajinscriptionlieux.component';

import { Cllajinscriptionuser2Component } from './cllaj/cllajinscriptionuser2/cllajinscriptionuser2.component';
import { Cllajinscription2Component } from './cllaj/cllajinscription2/cllajinscription2.component';
import { CllajinscriptioncfaComponent } from './cllaj/cllajinscriptioncfa/cllajinscriptioncfa.component';
import { NgxQrcodeStylingModule } from 'ngx-qrcode-styling';
import { RecontactFormComponent } from './recontact-form/recontact-form.component';
import { CllajInscriptionScanComponent } from './cllaj/cllajinscriptionscan/cllajinscriptionscan.component';
import { CllajbandeauComponent } from './cllaj/cllajbandeau/cllajbandeau.component';
import { SuiviGenericComponent } from './suivi-generic/suivi-generic.component';
import { ApiComparisonPanelComponent } from './api-comparison-panel/api-comparison-panel.component';
import { ApiSwitcherComponent } from './api-switcher/api-switcher.component';

@NgModule({
  declarations: [LoadingComponent,LayoutComponent,MenuComponent,RestComponent, UserMenuComponent,NavigationComponent, SuperMenuComponent, ThemePOLOHeaderFullwidthComponent, ThemePOLOCookieNotifyComponent, ThemePOLOSearchComponent,CguComponent, RgpdComponent, LayoutHeaderComponent, InstagramComponent, SubMenuComponent, HeaderComponent, AccordionComponent, LayoutFooterComponent
,CllajinscriptionComponent,
CllajinscriptionsalonsComponent,
CllajoffresComponent,
CllajinscriptionuserComponent,
CllajinscriptionlieuxComponent,Cllajinscriptionuser2Component,Cllajinscription2Component,CllajinscriptioncfaComponent
,CllajInscriptionScanComponent, CllajbandeauComponent, SuiviGenericComponent, RecontactFormComponent, ApiComparisonPanelComponent, ApiSwitcherComponent
  , ImagePickerComponent
  ],
  exports: [LoadingComponent,LayoutComponent,RestComponent,NavigationComponent,ThemePOLOHeaderFullwidthComponent,ThemePOLOCookieNotifyComponent,ThemePOLOSearchComponent, CguComponent, RgpdComponent,InstagramComponent,HeaderComponent,LayoutHeaderComponent,SubMenuComponent
    ,CllajinscriptionComponent,
CllajinscriptionsalonsComponent,
CllajoffresComponent,
CllajinscriptionuserComponent,
CllajinscriptionlieuxComponent,Cllajinscriptionuser2Component,Cllajinscription2Component,CllajinscriptioncfaComponent
,CllajInscriptionScanComponent, SuiviGenericComponent, RecontactFormComponent, ApiComparisonPanelComponent, ApiSwitcherComponent
  , ImagePickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DxSelectBoxModule,
    DxTooltipModule,
    DxFormModule,
    DxiValidationRuleModule,
    DxHtmlEditorModule,
    DxPopupModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxFileUploaderModule,
    NgxQrcodeStylingModule
  ],
})
export class ComponentsModule { }
